import React, { memo } from "react";

const AppOvertimeIcon = ({ color = "#ffffff", ...props }) => {
	return (
		<svg {...props} className="overtime-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_overtime_icon)">
				<path d="M8 2.66675C5.05448 2.66675 2.66667 5.05456 2.66667 8.00008C2.66667 10.9456 5.05448 13.3334 8 13.3334C10.9455 13.3334 13.3333 10.9456 13.3333 8.00008" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
				<path d="M8 5.33325V7.99992L9.66667 9.66659" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
				<path d="M11.3333 2.66675V5.33341" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
				<path d="M12.6667 4H10" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
			</g>
			<defs>
				<clipPath id="clip0_overtime_icon">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default memo(AppOvertimeIcon);
